export type Movie = {
  id: string;
  title: string;
  enTitle: string;
  year: number;
  region: string;
  genres: string[];
  director: string;
  cast: string[];
  duration: number;
  rating: number;
  views: number;
  tags: string[];
  synopsis: string;
  poster: string;
  updatedAt: string;
  highlight: string;
};

export const movies: Movie[] = [
  {
    id: "peach-blossom-2024",
    title: "蜜桃初熟",
    enTitle: "Peach Blossom",
    year: 2024,
    region: "中国",
    genres: ["爱情", "剧情"],
    director: "陈见山",
    cast: ["林知夏", "周牧野", "林母"],
    duration: 112,
    rating: 8.6,
    views: 486,
    tags: ["编辑精选", "夏日必看"],
    synopsis:
      "南方小城的夏天闷热而漫长，十九岁的林知夏在自家果园里等一场迟来的雨季。她与回乡修老屋的木匠周牧野相遇，两人在蝉鸣与桃香之间，完成了关于成长、告别与自我和解的一次漫长告白。",
    poster:
      "https://readdy.ai/api/search-image?query=Stylized%20cinematic%20key%20art%20for%20a%20coming%20of%20age%20film%2C%20a%20young%20woman%20silhouette%20standing%20among%20peach%20orchards%20at%20golden%20dusk%2C%20soft%20amber%20and%20peach%20tones%20with%20deep%20charcoal%20shadows%2C%20subtle%20film%20grain%2C%20painterly%20texture%2C%20empty%20space%20at%20top%2C%20no%20text%20no%20letters%2C%20vertical%20composition&width=600&height=900&seq=peach-poster-01&orientation=portrait",
    updatedAt: "2026-10-15",
    highlight: "一座果园，一整个夏天，和一次不敢说出口的喜欢。",
  },
  {
    id: "gentle-night-2023",
    title: "夜色温柔",
    enTitle: "Gentle Night",
    year: 2023,
    region: "中国",
    genres: ["爱情", "悬疑"],
    director: "沈婉",
    cast: ["苏晚", "程野", "老赵"],
    duration: 118,
    rating: 8.2,
    views: 372,
    tags: ["口碑佳作", "都市情感"],
    synopsis:
      "一通打错的深夜电话，让两个陌生人在城市里彼此靠近。苏晚是电台夜间节目的主持人，程野是接手老唱片店的沉默男人。当节目里那首未播完的歌再次响起，他们才发现彼此早已在对方的过去里出现过。",
    poster:
      "https://readdy.ai/api/search-image?query=Stylized%20cinematic%20poster%20art%20of%20a%20rainy%20city%20street%20at%20night%20with%20two%20distant%20figures%20under%20a%20warm%20streetlamp%2C%20peach%20amber%20glow%20against%20deep%20charcoal%20blue%20black%20shadows%2C%20soft%20film%20grain%2C%20painterly%20editorial%20illustration%2C%20no%20text%20no%20letters%2C%20vertical%20composition&width=600&height=900&seq=peach-poster-02&orientation=portrait",
    updatedAt: "2026-09-28",
    highlight: "城市的夜里，总有人替你听完那首歌。",
  },
  {
    id: "city-floating-light-2025",
    title: "都市浮光",
    enTitle: "Floating Light",
    year: 2025,
    region: "中国",
    genres: ["剧情", "悬疑"],
    director: "高柏川",
    cast: ["许南", "姜黎", "唐一鸣"],
    duration: 126,
    rating: 8.8,
    views: 519,
    tags: ["新片上线", "高分推荐"],
    synopsis:
      "一栋即将拆除的老写字楼里，还留着六家没搬走的公司。广告导演许南为拍摄最后一条片子回到这里，逐渐拼凑出十二年前那场火灾的另一种版本。浮光掠影之下，每个人都曾替别人保守一个秘密。",
    poster:
      "https://readdy.ai/api/search-image?query=Stylized%20cinematic%20poster%20of%20a%20towering%20old%20office%20building%20at%20dusk%20seen%20from%20a%20low%20angle%2C%20glowing%20windows%20in%20warm%20peach%20amber%20against%20dark%20charcoal%20structures%2C%20geometric%20light%20shafts%2C%20painterly%20texture%20with%20film%20grain%2C%20no%20text%20no%20letters%2C%20vertical%20poster%20composition&width=600&height=900&seq=peach-poster-03&orientation=portrait",
    updatedAt: "2026-10-12",
    highlight: "城市把光打在每个人脸上，却照不到他们的背面。",
  },
  {
    id: "endless-summer-2022",
    title: "长夏未央",
    enTitle: "Endless Summer",
    year: 2022,
    region: "日本",
    genres: ["爱情", "治愈"],
    director: "山崎遥",
    cast: ["宫本葵", "橘柊", "松本千夏"],
    duration: 108,
    rating: 8.4,
    views: 298,
    tags: ["治愈系", "海边物语"],
    synopsis:
      "海边小镇的旧旅馆里，葵每年夏天都会接待一位只住一晚的客人。第十年，客人带着一个小女孩出现。潮水退去之后，关于母亲、约定与告别的话题，终于被认真地说出口。",
    poster:
      "https://readdy.ai/api/search-image?query=Stylized%20cinematic%20poster%20of%20a%20quiet%20seaside%20town%20with%20a%20wooden%20guesthouse%20and%20sunlit%20shoreline%2C%20warm%20peach%20sunset%20haze%20with%20muted%20charcoal%20shadows%2C%20simplified%20painterly%20shapes%2C%20soft%20film%20grain%2C%20tranquil%20mood%2C%20no%20text%20no%20letters%2C%20vertical%20composition&width=600&height=900&seq=peach-poster-04&orientation=portrait",
    updatedAt: "2026-08-20",
    highlight: "有些夏天，会在很多年以后才真正结束。",
  },
  {
    id: "against-the-light-2024",
    title: "逆光飞行",
    enTitle: "Against The Light",
    year: 2024,
    region: "美国",
    genres: ["动作", "冒险"],
    director: "Marcus Vale",
    cast: ["Evan Cole", "Nora Hale", "Diaz"],
    duration: 132,
    rating: 7.9,
    views: 441,
    tags: ["视效大片", "高空动作"],
    synopsis:
      "一名退役的试飞员被迫驾驶一架没有编号的货机穿越风暴带，机上装着足以改变城市命运的东西。在三万英尺的高空，他必须同时对抗失压的座舱、失联的地面塔台，以及自己不愿记起的过去。",
    poster:
      "https://readdy.ai/api/search-image?query=Stylized%20cinematic%20action%20poster%20of%20a%20lone%20cargo%20plane%20flying%20through%20a%20dramatic%20storm%20cloud%2C%20backlit%20by%20warm%20peach%20amber%20sunlight%20with%20dark%20charcoal%20storm%20shadows%2C%20dramatic%20diagonal%20composition%2C%20painterly%20illustration%20with%20film%20grain%2C%20no%20text%20no%20letters%20vertical%20poster&width=600&height=900&seq=peach-poster-05&orientation=portrait",
    updatedAt: "2026-09-30",
    highlight: "三万英尺之上，没有第二次机会。",
  },
  {
    id: "deep-sea-echo-2023",
    title: "深海回声",
    enTitle: "Echo From The Deep",
    year: 2023,
    region: "美国",
    genres: ["科幻", "悬疑"],
    director: "Iris Lang",
    cast: ["Owen Park", "Mia Sanders", "Ken Ruiz"],
    duration: 124,
    rating: 8.7,
    views: 405,
    tags: ["硬科幻", "烧脑"],
    synopsis:
      "深潜研究站收到一段来自海沟底部的重复信号，节奏与二十年前失踪的考察队求救码完全一致。当值班工程师下潜确认时，她发现信号源正在缓慢地学习人类的语言。",
    poster:
      "https://readdy.ai/api/search-image?query=Stylized%20sci%20fi%20poster%20of%20a%20solitary%20deep%20sea%20research%20station%20glowing%20beneath%20dark%20water%2C%20a%20single%20beam%20of%20warm%20amber%20peach%20light%20cutting%20through%20deep%20charcoal%20depths%2C%20mysterious%20geometric%20ripples%2C%20painterly%20texture%2C%20film%20grain%2C%20no%20text%20no%20letters%2C%20vertical%20composition&width=600&height=900&seq=peach-poster-06&orientation=portrait",
    updatedAt: "2026-09-16",
    highlight: "海沟深处，有什么在重复我们的呼救。",
  },
  {
    id: "seventh-second-2025",
    title: "午夜第七秒",
    enTitle: "The Seventh Second",
    year: 2025,
    region: "韩国",
    genres: ["悬疑", "剧情"],
    director: "尹在勋",
    cast: ["韩瑞妍", "李道均", "崔敏书"],
    duration: 116,
    rating: 8.5,
    views: 467,
    tags: ["年度悬疑", "反转不断"],
    synopsis:
      "地铁末班车每次经过同一段隧道，监控都会丢失七秒钟。调度员瑞妍在逐帧比对时，看见了一个本不该出现在画面里的自己。她开始怀疑，这七秒里发生的事，也许每天都在真实世界里重演。",
    poster:
      "https://readdy.ai/api/search-image?query=Stylized%20thriller%20poster%20of%20an%20empty%20late%20night%20subway%20platform%20with%20long%20repeating%20corridor%20lines%20and%20a%20distant%20lone%20figure%2C%20warm%20sodium%20amber%20lighting%20with%20deep%20charcoal%20tunnel%20darkness%2C%20eerie%20symmetry%2C%20painterly%20film%20grain%2C%20no%20text%20no%20letters%2C%20vertical%20poster&width=600&height=900&seq=peach-poster-07&orientation=portrait",
    updatedAt: "2026-10-08",
    highlight: "丢失的七秒，藏着另一个你。",
  },
  {
    id: "camellia-bloom-2021",
    title: "山茶花开",
    enTitle: "When Camellias Bloom",
    year: 2021,
    region: "中国",
    genres: ["家庭", "剧情"],
    director: "赵青禾",
    cast: ["何秀兰", "赵川", "小满"],
    duration: 121,
    rating: 8.9,
    views: 331,
    tags: ["催泪", "女性叙事"],
    synopsis:
      "母亲过世后，赵川回到山村整理老屋，在衣柜深处找到二十三封没有寄出的信。信里写着一个他从未听说过的名字，也写着母亲一生中最想留住的那年春天。",
    poster:
      "https://readdy.ai/api/search-image?query=Stylized%20emotional%20drama%20poster%20of%20a%20rural%20stone%20house%20courtyard%20with%20blooming%20camellia%20flowers%2C%20one%20elderly%20woman%20silhouette%20in%20the%20doorway%2C%20warm%20peach%20daylight%20with%20soft%20charcoal%20shadows%2C%20painterly%20brush%20texture%20and%20film%20grain%2C%20no%20text%20no%20letters%2C%20vertical%20composition&width=600&height=900&seq=peach-poster-08&orientation=portrait",
    updatedAt: "2026-07-11",
    highlight: "她把一生写进信里，却一封都没有寄出。",
  },
  {
    id: "silent-snow-2020",
    title: "雪落无声",
    enTitle: "Silent Snow",
    year: 2020,
    region: "中国",
    genres: ["文艺", "剧情"],
    director: "白屿",
    cast: ["江野", "秦知", "老邮差"],
    duration: 104,
    rating: 8.1,
    views: 214,
    tags: ["冷门佳片", "北方叙事"],
    synopsis:
      "北方小城的冬天，邮差每天要走过同一条结了冰的街。他把一封无人认领的信带在身上整整一个冬天，直到信上的名字出现在他面前。有些等待，比雪更安静。",
    poster:
      "https://readdy.ai/api/search-image?query=Stylized%20minimalist%20poster%20of%20a%20snowy%20northern%20town%20street%20with%20a%20single%20postman%20figure%20walking%20through%20falling%20snow%2C%20warm%20peach%20window%20lights%20against%20cool%20charcoal%20grey%20snow%20shadows%2C%20quiet%20negative%20space%2C%20painterly%20texture%20and%20grain%2C%20no%20text%20no%20letters%2C%20vertical%20poster&width=600&height=900&seq=peach-poster-09&orientation=portrait",
    updatedAt: "2026-06-02",
    highlight: "雪落在肩上，也落在那封没有地址的信上。",
  },
  {
    id: "south-of-han-river-2024",
    title: "汉江以南",
    enTitle: "South Of Han",
    year: 2024,
    region: "韩国",
    genres: ["犯罪", "剧情"],
    director: "朴承宇",
    cast: ["郑泰河", "申恩彩", "金武烈"],
    duration: 129,
    rating: 8.3,
    views: 356,
    tags: ["犯罪片", "夜色汉江"],
    synopsis:
      "汉江以南的老城区里，一名即将退休的刑警接手了一桩没有尸体的案子。所有的线索都指向一间早已关闭的洗衣店，而店主是他二十年前的线人。",
    poster:
      "https://readdy.ai/api/search-image?query=Stylized%20crime%20drama%20poster%20of%20a%20narrow%20old%20city%20alley%20beside%20a%20river%20at%20night%20with%20wet%20pavement%20reflections%2C%20warm%20amber%20signage%20glow%20with%20heavy%20charcoal%20shadows%2C%20gritty%20painterly%20texture%20and%20film%20grain%2C%20no%20text%20no%20letters%2C%20vertical%20composition&width=600&height=900&seq=peach-poster-10&orientation=portrait",
    updatedAt: "2026-09-05",
    highlight: "没有尸体的案子，最需要一个答案。",
  },
  {
    id: "glass-planet-2022",
    title: "玻璃星球",
    enTitle: "Glass Planet",
    year: 2022,
    region: "美国",
    genres: ["科幻", "剧情"],
    director: "Noah Renn",
    cast: ["Ada Quinn", "Theo Marsh", "Lira"],
    duration: 137,
    rating: 8.6,
    views: 289,
    tags: ["太空美学", "哲学思辨"],
    synopsis:
      "人类在玻璃质地的星球上建立了第一座透明城市，所有居民的情绪都会被建筑表面折射成光。一名负责修复裂痕的工程师发现，城市最深处那道无法愈合的缝隙，来自一段被集体删除的记忆。",
    poster:
      "https://readdy.ai/api/search-image?query=Stylized%20sci%20fi%20poster%20of%20a%20translucent%20glass%20city%20on%20an%20alien%20planet%20surface%20refracting%20warm%20peach%20amber%20sunlight%20into%20geometric%20beams%2C%20deep%20charcoal%20space%20background%20with%20faint%20stars%2C%20elegant%20painterly%20illustration%2C%20film%20grain%2C%20no%20text%20no%20letters%2C%20vertical%20composition&width=600&height=900&seq=peach-poster-11&orientation=portrait",
    updatedAt: "2026-05-22",
    highlight: "透明的城市里，最难藏住的是一段记忆。",
  },
  {
    id: "summer-train-2019",
    title: "夏日列车",
    enTitle: "Summer Train",
    year: 2019,
    region: "日本",
    genres: ["青春", "治愈"],
    director: "小林原",
    cast: ["水野澪", "高桥悠", "森川老师"],
    duration: 99,
    rating: 8.0,
    views: 243,
    tags: ["青春片", "铁路风景"],
    synopsis:
      "高考结束的那个夏天，四个同学买了一张可以随意下车的通票。他们沿着海岸线一路向西，在终点站前决定，把那些没说完的话留在车厢里。",
    poster:
      "https://readdy.ai/api/search-image?query=Stylized%20youth%20film%20poster%20of%20a%20small%20seaside%20railway%20train%20curving%20along%20the%20coast%20at%20late%20afternoon%2C%20four%20tiny%20student%20silhouettes%20by%20the%20window%2C%20warm%20peach%20sunlight%20with%20charcoal%20blue%20shadows%2C%20nostalgic%20painterly%20texture%20and%20grain%2C%20no%20text%20no%20letters%2C%20vertical%20poster&width=600&height=900&seq=peach-poster-12&orientation=portrait",
    updatedAt: "2026-04-18",
    highlight: "终点站之前，我们还有一整段夏天。",
  },
  {
    id: "wind-chaser-2025",
    title: "追风者",
    enTitle: "Wind Chaser",
    year: 2025,
    region: "中国",
    genres: ["动作", "冒险"],
    director: "方程",
    cast: ["宋远", "阿依", "老雷"],
    duration: 128,
    rating: 8.0,
    views: 392,
    tags: ["新片上线", "公路动作"],
    synopsis:
      "一支民间气象小队深入戈壁追踪罕见的沙暴带，只为拿回一批被风沙掩埋的观测数据。当补给耗尽，他们必须在风眼里做出取舍：带走数据，还是带走队友。",
    poster:
      "https://readdy.ai/api/search-image?query=Stylized%20adventure%20poster%20of%20a%20desert%20highway%20with%20a%20small%20convoy%20driving%20toward%20a%20massive%20sandstorm%20wall%2C%20warm%20peach%20amber%20sky%20against%20deep%20charcoal%20storm%20shadow%2C%20dramatic%20scale%20contrast%2C%20painterly%20illustration%20with%20film%20grain%2C%20no%20text%20no%20letters%2C%20vertical%20composition&width=600&height=900&seq=peach-poster-13&orientation=portrait",
    updatedAt: "2026-10-14",
    highlight: "风眼里，只能带走一样东西。",
  },
  {
    id: "old-town-story-2018",
    title: "旧城故事",
    enTitle: "Old Town Story",
    year: 2018,
    region: "中国",
    genres: ["剧情", "家庭"],
    director: "任行",
    cast: ["顾伯", "柳青", "小周"],
    duration: 115,
    rating: 8.2,
    views: 187,
    tags: ["城市记忆", "慢节奏"],
    synopsis:
      "拆迁公告贴上墙的那天，修表匠顾伯决定把自己铺子里的每一只钟都修好，再关门。整条街的人陆续来找他，带着各自停在某个时刻的故事。",
    poster:
      "https://readdy.ai/api/search-image?query=Stylized%20nostalgic%20poster%20of%20an%20old%20watchmaker%20shop%20interior%20filled%20with%20clocks%2C%20warm%20peach%20lamp%20glow%20and%20deep%20charcoal%20shadows%2C%20dust%20motes%20in%20the%20light%2C%20detailed%20painterly%20texture%20and%20film%20grain%2C%20quiet%20melancholy%2C%20no%20text%20no%20letters%2C%20vertical%20poster&width=600&height=900&seq=peach-poster-14&orientation=portrait",
    updatedAt: "2026-03-09",
    highlight: "整条街的钟，都停在各自最好的时刻。",
  },
  {
    id: "north-of-equator-2021",
    title: "赤道以北",
    enTitle: "North Of The Equator",
    year: 2021,
    region: "美国",
    genres: ["冒险", "剧情"],
    director: "Lena Ortiz",
    cast: ["Jonah Reed", "Ivy Chen", "Baker"],
    duration: 133,
    rating: 7.8,
    views: 228,
    tags: ["海岛冒险", "父子"],
    synopsis:
      "一对多年未见的父子为了完成母亲留下的航海日志，驾驶一艘旧帆船横渡赤道。在无风的第十九天，他们终于谈起那场让家里少一个人的台风。",
    poster:
      "https://readdy.ai/api/search-image?query=Stylized%20ocean%20adventure%20poster%20of%20a%20small%20sailboat%20alone%20on%20a%20vast%20open%20sea%20under%20a%20huge%20warm%20peach%20sunset%20sky%2C%20deep%20charcoal%20water%20shadows%20below%2C%20minimal%20expansive%20composition%20with%20negative%20space%2C%20painterly%20texture%20and%20film%20grain%2C%20no%20text%20no%20letters%2C%20vertical%20poster&width=600&height=900&seq=peach-poster-15&orientation=portrait",
    updatedAt: "2026-02-25",
    highlight: "在无风的第十九天，他们终于开口。",
  },
  {
    id: "silent-confession-2023",
    title: "无声告白",
    enTitle: "Silent Confession",
    year: 2023,
    region: "中国",
    genres: ["悬疑", "剧情"],
    director: "罗砚",
    cast: ["温婷", "路遥", "陈默"],
    duration: 111,
    rating: 8.4,
    views: 347,
    tags: ["女性悬疑", "一镜到底"],
    synopsis:
      "手语翻译温婷被请去协助一桩案件，唯一的证人是位听障女孩。随着翻译的每一句话，她意识到自己正在把一个精心设计的真相，一点点译错。",
    poster:
      "https://readdy.ai/api/search-image?query=Stylized%20mystery%20poster%20showing%20two%20womens%20faces%20partly%20in%20shadow%20facing%20each%20other%20across%20a%20glass%20partition%2C%20warm%20peach%20amber%20rim%20light%20with%20deep%20charcoal%20background%2C%20subtle%20hand%20gesture%20detail%2C%20painterly%20film%20grain%20%2C%20no%20text%20no%20letters%2C%20vertical%20composition&width=600&height=900&seq=peach-poster-16&orientation=portrait",
    updatedAt: "2026-08-02",
    highlight: "每译错一句，真相就更远一点。",
  },
  {
    id: "sakura-inn-2020",
    title: "樱花旅店",
    enTitle: "Sakura Inn",
    year: 2020,
    region: "日本",
    genres: ["爱情", "治愈"],
    director: "藤井千尋",
    cast: ["坂本栞", "大野诚", "老板娘"],
    duration: 106,
    rating: 8.3,
    views: 201,
    tags: ["春日必看", "小镇爱情"],
    synopsis:
      "樱花季的最后一晚，旅店只剩两位客人：一位来退掉婚约的上班族，一位来赴约却迟到了七年的插画家。老板娘把走廊尽头的房间留给他们，假装什么都没看见。",
    poster:
      "https://readdy.ai/api/search-image?query=Stylized%20romantic%20poster%20of%20a%20traditional%20japanese%20inn%20entrance%20framed%20by%20blooming%20cherry%20branches%2C%20warm%20peach%20pink%20petals%20drifting%20with%20deep%20charcoal%20wooden%20shadows%2C%20soft%20lantern%20glow%2C%20painterly%20texture%20and%20film%20grain%2C%20no%20text%20no%20letters%2C%20vertical%20poster%20composition&width=600&height=900&seq=peach-poster-17&orientation=portrait",
    updatedAt: "2026-03-28",
    highlight: "走廊尽头的房间，留给迟到七年的人。",
  },
  {
    id: "night-walker-2022",
    title: "都市夜行者",
    enTitle: "Night Walker",
    year: 2022,
    region: "韩国",
    genres: ["动作", "悬疑"],
    director: "车敏浩",
    cast: ["权赫", "柳真儿", "白社长"],
    duration: 120,
    rating: 7.7,
    views: 316,
    tags: ["动作爽片", "夜戏美学"],
    synopsis:
      "一个只接夜间代驾单的男人，在某个凌晨接到了一位浑身是血的乘客。后备箱里的东西让他不得不在天亮前跑遍整座城市，把所有欠账一次结清。",
    poster:
      "https://readdy.ai/api/search-image?query=Stylized%20urban%20action%20poster%20of%20a%20lone%20car%20speeding%20through%20a%20neon%20lit%20rainy%20city%20street%20at%20night%2C%20warm%20peach%20amber%20light%20trails%20against%20deep%20charcoal%20buildings%2C%20motion%20blur%2C%20gritty%20painterly%20illustration%20with%20film%20grain%2C%20no%20text%20no%20letters%2C%20vertical%20poster&width=600&height=900&seq=peach-poster-18&orientation=portrait",
    updatedAt: "2026-07-19",
    highlight: "天亮之前，把所有的账结清。",
  },
  {
    id: "letter-from-cloud-2024",
    title: "云端来信",
    enTitle: "Letters From Above",
    year: 2024,
    region: "中国",
    genres: ["爱情", "奇幻"],
    director: "祝晓",
    cast: ["岑星", "季白", "小邮局"],
    duration: 110,
    rating: 8.2,
    views: 274,
    tags: ["轻奇幻", "温柔"],
    synopsis:
      "高山气象站的气象员每月会收到一封写在云图背面的信，寄件人栏永远空白。她试着回信，于是开始了一段跨越十年的通信。",
    poster:
      "https://readdy.ai/api/search-image?query=Stylized%20fantasy%20romance%20poster%20of%20a%20weather%20station%20on%20a%20mountain%20peak%20above%20a%20sea%20of%20clouds%2C%20warm%20peach%20sunrise%20light%20with%20soft%20charcoal%20cloud%20shadows%2C%20a%20single%20paper%20letter%20floating%2C%20painterly%20texture%20and%20film%20grain%2C%20no%20text%20no%20letters%2C%20vertical%20poster&width=600&height=900&seq=peach-poster-19&orientation=portrait",
    updatedAt: "2026-09-12",
    highlight: "信从云上来，落在一个人的十年里。",
  },
  {
    id: "last-ferry-2017",
    title: "最后一班渡轮",
    enTitle: "The Last Ferry",
    year: 2017,
    region: "中国香港",
    genres: ["剧情", "家庭"],
    director: "梁启生",
    cast: ["陈伯", "阿珊", "细强"],
    duration: 102,
    rating: 8.5,
    views: 176,
    tags: ["经典重看", "海边"],
    synopsis:
      "跨海大桥通车前的最后一晚，开了三十年的渡轮船长决定照常跑完最后一班。船上只有三个乘客，每个人都带着一件不愿带上岸的旧事。",
    poster:
      "https://readdy.ai/api/search-image?query=Stylized%20melancholic%20poster%20of%20an%20old%20ferry%20crossing%20a%20harbor%20at%20dusk%20with%20a%20fading%20city%20skyline%20behind%2C%20warm%20peach%20sunset%20reflections%20on%20dark%20charcoal%20water%2C%20lonely%20small%20figures%20on%20deck%2C%20painterly%20texture%20and%20film%20grain%2C%20no%20text%20no%20letters%2C%20vertical%20poster&width=600&height=900&seq=peach-poster-20&orientation=portrait",
    updatedAt: "2026-01-30",
    highlight: "桥通了以后，这条航线就再也没有了。",
  },
  {
    id: "weekend-comedy-club-2024",
    title: "周末喜剧社",
    enTitle: "Weekend Comedy Club",
    year: 2024,
    region: "中国",
    genres: ["喜剧", "剧情"],
    director: "马小川",
    cast: ["大彭", "阿May", "老范"],
    duration: 98,
    rating: 7.6,
    views: 259,
    tags: ["下饭喜剧", "笑中带泪"],
    synopsis:
      "一家快要关门的小剧场，五个不赚钱的喜剧演员，决定在最后一个月里演一场自己真正想演的戏。观众没来多少，但他们把想说的话都讲完了。",
    poster:
      "https://readdy.ai/api/search-image?query=Stylized%20warm%20comedy%20poster%20of%20a%20tiny%20underground%20theater%20stage%20with%20a%20single%20microphone%20and%20empty%20chairs%2C%20warm%20peach%20spotlight%20glow%20against%20deep%20charcoal%20auditorium%20shadows%2C%20playful%20painterly%20illustration%20with%20film%20grain%2C%20no%20text%20no%20letters%2C%20vertical%20poster&width=600&height=900&seq=peach-poster-21&orientation=portrait",
    updatedAt: "2026-06-21",
    highlight: "不赚钱的戏，也要演完最后一场。",
  },
  {
    id: "fog-house-2021",
    title: "雾宅",
    enTitle: "The Fog House",
    year: 2021,
    region: "日本",
    genres: ["恐怖", "悬疑"],
    director: "黑泽修",
    cast: ["吉田澪", "佐藤圭", "小夜"],
    duration: 94,
    rating: 7.5,
    views: 233,
    tags: ["氛围恐怖", "胆小慎入"],
    synopsis:
      "一对夫妻搬进山里的老宅，每天清晨屋外都会起雾。雾散之后，院子里的脚印总是比昨天多一排，而家里的碗筷，也开始变成四个人份。",
    poster:
      "https://readdy.ai/api/search-image?query=Stylized%20atmospheric%20horror%20poster%20of%20a%20remote%20japanese%20wooden%20house%20surrounded%20by%20thick%20fog%20at%20dawn%2C%20one%20faint%20warm%20amber%20window%20light%20against%20heavy%20charcoal%20grey%20mist%2C%20eerie%20empty%20foreground%2C%20painterly%20texture%20and%20film%20grain%2C%20no%20text%20no%20letters%2C%20vertical%20composition&width=600&height=900&seq=peach-poster-22&orientation=portrait",
    updatedAt: "2026-05-06",
    highlight: "雾散以后，家里的碗筷多了一副。",
  },
  {
    id: "laughing-life-2022",
    title: "笑场人生",
    enTitle: "Life Is A Outtake",
    year: 2022,
    region: "中国",
    genres: ["喜剧", "家庭"],
    director: "吴一乐",
    cast: ["郑好", "王阿姨", "小胖"],
    duration: 96,
    rating: 7.9,
    views: 221,
    tags: ["合家欢", "轻松"],
    synopsis:
      "一个总在片场笑场的群演，意外被选为家庭聚会的主持人。为了让全家人满意，他把婚礼、寿宴和满月酒的流程混在了一起，结果所有人都笑出了眼泪。",
    poster:
      "https://readdy.ai/api/search-image?query=Stylized%20cheerful%20family%20comedy%20poster%20with%20a%20long%20dinner%20table%20lit%20by%20warm%20peach%20lanterns%20in%20a%20courtyard%2C%20colorful%20chairs%20and%20plates%20in%20simplified%20shapes%2C%20deep%20charcoal%20evening%20background%2C%20playful%20painterly%20illustration%20with%20grain%2C%20no%20text%20no%20letters%2C%20vertical%20poster&width=600&height=900&seq=peach-poster-23&orientation=portrait",
    updatedAt: "2026-04-02",
    highlight: "一家人凑齐的那天，怎么演都是喜剧。",
  },
  {
    id: "puppet-night-2023",
    title: "木偶之夜",
    enTitle: "Night Of Puppets",
    year: 2023,
    region: "美国",
    genres: ["恐怖", "悬疑"],
    director: "Colin Vane",
    cast: ["Ruth Bell", "Sam Doyle", "The Puppeteer"],
    duration: 101,
    rating: 7.4,
    views: 198,
    tags: ["小镇怪谈", "氛围感"],
    synopsis:
      "小镇废弃的剧院每逢雨夜都会亮灯，台上演着一出没有观众的傀儡戏。前来调查的记者发现，戏里的角色正一个一个对应着镇上的居民。",
    poster:
      "https://readdy.ai/api/search-image?query=Stylized%20eerie%20poster%20of%20an%20abandoned%20theater%20stage%20with%20hanging%20marionette%20puppets%20and%20a%20single%20dusty%20spotlight%2C%20warm%20peach%20amber%20beam%20cutting%20through%20deep%20charcoal%20darkness%2C%20unsettling%20symmetry%2C%20painterly%20texture%20with%20film%20grain%2C%20no%20text%20no%20letters%2C%20vertical%20poster&width=600&height=900&seq=peach-poster-24&orientation=portrait",
    updatedAt: "2026-02-08",
    highlight: "戏台上的角色，正在一个一个对上镇上的人。",
  },
];

export const heroSlides = [
  {
    movieId: "city-floating-light-2025",
    kicker: "本周焦点 · 新片上线",
    title: "都市浮光",
    description:
      "一栋即将拆除的老写字楼，六家没搬走的公司，和十二年前那场火灾的另一种版本。",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20cinematic%20wide%20key%20art%20of%20an%20old%20city%20office%20building%20at%20dusk%20with%20glowing%20warm%20peach%20windows%20and%20layered%20charcoal%20city%20silhouettes%2C%20light%20haze%20and%20rain%20texture%2C%20painterly%20editorial%20illustration%2C%20lots%20of%20dark%20negative%20space%20on%20the%20left%2C%20no%20text%20no%20letters&width=1600&height=900&seq=peach-hero-01&orientation=landscape",
    badges: ["2025", "剧情 / 悬疑", "评分 8.8"],
  },
  {
    movieId: "seventh-second-2025",
    kicker: "年度悬疑 · 强烈推荐",
    title: "午夜第七秒",
    description:
      "地铁监控每次都会丢失七秒钟。在逐帧比对时，调度员看见了一个本不该出现在画面里的自己。",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20cinematic%20wide%20shot%20of%20an%20empty%20late%20night%20subway%20platform%20with%20long%20repeating%20tunnel%20lines%20and%20warm%20sodium%20amber%20lighting%20fading%20into%20deep%20charcoal%20darkness%2C%20lonely%20atmospheric%20mood%2C%20painterly%20film%20texture%2C%20dark%20empty%20space%20on%20one%20side%2C%20no%20text%20no%20letters&width=1600&height=900&seq=peach-hero-02&orientation=landscape",
    badges: ["2025", "悬疑 / 剧情", "评分 8.5"],
  },
  {
    movieId: "peach-blossom-2024",
    kicker: "编辑精选 · 夏日必看",
    title: "蜜桃初熟",
    description:
      "南方小城的夏天闷热而漫长，十九岁的她在自家果园里等一场迟来的雨季。",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20cinematic%20wide%20key%20art%20of%20a%20sunlit%20peach%20orchard%20at%20golden%20hour%20with%20a%20young%20woman%20silhouette%20walking%20between%20trees%2C%20warm%20peach%20amber%20haze%20and%20deep%20charcoal%20shadows%2C%20painterly%20editorial%20texture%2C%20soft%20romantic%20mood%2C%20no%20text%20no%20letters%2C%20wide%20negative%20space&width=1600&height=900&seq=peach-hero-03&orientation=landscape",
    badges: ["2024", "爱情 / 剧情", "评分 8.6"],
  },
];

export const genres = [
  { name: "爱情", icon: "ri-heart-3-line", desc: "心动与错过" },
  { name: "动作", icon: "ri-flashlight-fill", desc: "肾上腺素" },
  { name: "喜剧", icon: "ri-emotion-happy-line", desc: "下饭必备" },
  { name: "科幻", icon: "ri-planet-line", desc: "想象边界" },
  { name: "悬疑", icon: "ri-eye-line", desc: "烧脑反转" },
  { name: "剧情", icon: "ri-book-open-line", desc: "人间故事" },
  { name: "恐怖", icon: "ri-ghost-line", desc: "胆小慎入" },
  { name: "治愈", icon: "ri-sun-line", desc: "温柔一下" },
];

export const regions = ["全部", "中国", "中国香港", "美国", "韩国", "日本"];

export const years = ["全部", "2025", "2024", "2023", "2022", "2021", "2020", "更早"];

export const sortOptions = [
  { key: "updated", label: "最近更新" },
  { key: "hot", label: "热门度" },
  { key: "rating", label: "评分最高" },
];

export const hotSearches = ["蜜桃初熟", "悬疑", "韩剧电影", "都市浮光", "治愈系", "2025新片"];